// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "src/assets/js/" + chunkId + "." + {"2":"6d572c52","297":"e47670f6","394":"a2450725","459":"90613717","478":"c1b6f5a4","542":"4948ba6a","658":"b7a42c61","677":"bca2f2db","965":"a24bcfde"}[chunkId] + ".js";
};